import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_PATIENT_RESOURCES_BY_ID_KEY } from '_api/queries/resource/useGetAllPatientResourcesByID';
import { AddResourceToPatientPayload } from '_api/types';

export const ADD_RESOURCE_TO_PATIENT_KEY = 'add-resource-to-patient';

export const useAddResourceToPatient = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, AddResourceToPatientPayload[]>(
    () => '/resource/add-patient-resource',
    'post',
    {},
    {
      mutationKey: [ADD_RESOURCE_TO_PATIENT_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_RESOURCES_BY_ID_KEY],
        });
      },
    },
    (body: AddResourceToPatientPayload[]) => JSON.stringify(body),
  );
};
